"use client";

import { Content } from "@/services/content/types";
import { createImageSizes, createImageUrl } from "@/utils/image";
import Image from "next/image";
import Category from "../category";

type HeroProps = {
  title?: string;
  mainCategory?: Content.Category;
  imageCaption?: string;
  images?: {
    url: string;
    alt?: string;
    title?: any;
    photographer?: string;
  }[];
};

const StoryImage = ({
  title,
  mainCategory,
  images,
  imageCaption,
}: HeroProps) => {
  if (!images) return null;

  return (
    <div className="w-full h-[calc(100dvh-260px)] md:h-[calc(100dvh-250px)] relative -mt-8 mb-8 main-image-area">
      <div className="w-full h-full absolute top-0 z-10">
        <Image
          fill
          style={{
            objectFit: "cover",
            objectPosition: "center center",
          }}
          alt={images[0].alt || ""}
          sizes={createImageSizes({
            mobile: "100vw",
            tablet: "100vw",
            desktop: "100vw",
          })}
          quality={90}
          className="cursor-pointer"
          src={createImageUrl(images[0].url, { crop: "16:9" })}
          // TODO: Quick fix to prevent adding "2500" device size to all images
          loader={({ src, width, quality }) => {
            const url = new URL(src);

            url.searchParams.set("auto", "webp");

            // If width is maxed at 960, override it for hero images only
            if (width === 960) {
              url.searchParams.set("width", "2500");
            } else {
              url.searchParams.set("width", width.toString());
            }

            url.searchParams.set("quality", (quality || 90).toString());

            return url.href;
          }}
        />
      </div>
      <div className="bg-gradient-to-t from-static-black to-transparent absolute bottom-0 h-[90%] w-full z-10"></div>
      <div className="absolute left-1/2 transform -translate-x-1/2 bottom-4 z-10 container space-y-4 lg:space-y-8 lg:max-w-[960px] lg:px-24 mx-auto">
        {mainCategory && (
          <Category category={mainCategory} showFollowToggle isLink inverted />
        )}
        <h1 className="font-bold text-4xl md:text-5xl lg:text-6xl text-static-white !mt-2">
          {title}
        </h1>
        {imageCaption && (
          <p className="md:text-xl text-static-white">{imageCaption}</p>
        )}
      </div>
    </div>
  );
};

export default StoryImage;
